<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col>
          <h1 class="mt-n5">{{ $t('Create New') + ' - ' + $t('Delivery') }}</h1>
        </v-col>
      </v-row>
      <v-card>
        <v-card-text class="black--text">
          <v-text-field v-model="facilityShow" :label="$t('Facility')" readonly></v-text-field>
          <v-autocomplete v-if="createAgreementDelivery" :items="agreements" v-model="agreementNo" :label="$t('Agreement')" @change="agreementChanged" v-on:keyup="searchAgreement = $event.target.value" @keyup="searchDelayedAgreement" :rules="(isRequired('Agreement') ? [rules.required] : [])"></v-autocomplete>
          <v-text-field v-if="!createAgreementDelivery" v-model="delivery.AgreementNo" :label="$t('AgreementNo')" readonly></v-text-field>
          <v-text-field v-if="!createAgreementDelivery" v-model="this.AgreementName" :label="$t('AgreementName')" readonly></v-text-field>
          <!-- <v-text-field v-model="delivery.No" :label="$t('DeliveryNo')" :rules="[rules.required]"></v-text-field> -->
          <v-text-field v-model="delivery.Name" :label="$t('DeliveryName')"></v-text-field>
          <v-row no-gutters>
            <v-col cols="10">
              <v-combobox class="mt-0" :disabled="zipCodes.length===0" :label="$t('Zip Code')" hide-details deletable-chips chips small-chips :items="zipCodes" v-model="delivery.CouplingNo" solo @change="zipCodeChanged"></v-combobox>
              <v-progress-linear v-if="searching" :indeterminate="true" class="mt-n8"></v-progress-linear>
            </v-col>
          </v-row>
        </v-card-text>
        <h3 class="ml-4 mt-2 mr-3">{{ $t('ATTENTION') + ' : ' + $t('Created deliveries can not be deleted on the portal') }}</h3>
      <v-card-actions class="mt-n10">
        <v-spacer></v-spacer>
        <v-btn color="success" @click="submit" :loading="submitting" :disabled="validate()" min-width="97px">{{ $t('Save') }}</v-btn>
        <v-btn color="primary" @click="preventLeave = false; $router.go(-1)">{{$t("Cancel")}}</v-btn>
      </v-card-actions>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import formatDate from '@/core/mixins/formatDate'
import preventLeave from '@/core/mixins/preventLeave'
import * as LocalStorage from '@/core/local-storage'
import { saveDeliveriesDetails, loadZipCodes } from '@/modules/workplaces/workplaces'
import * as DateUtil from '@/core/date'
import ct from '@/core/mixins/common-translations'
import { validSearchKeyUp } from '@/core/utils'
import * as Security from '@/core/security'
import * as Archive from '@/core/archive'
import rules from '@/core/mixins/common-rules'

export default {
  mixins: [formatDate, rules, preventLeave, ct],
  data () {
    return {
      loading: true,
      submitting: false,
      valid: true,
      redirectTo: 'workplaces',
      zipCodes: [], // valid Vehicles LicensePlateNos for for selected facility
      facilityNo: '',
      facilityShow: '',
      delivery: {
        AgreementNo: 0,
        No: 0,
        CustomerName: '',
        ArticleName: '',
        Foreman: '',
        LoadTimeLatest: '2000-03-06T08:43:23.091Z',
        AmountDelivered: '0',
        AmountTotal: '0',
        SelectedVehiclesNum: [], // current user-selected LicensePlateNos for vehicles
        Details: [],
        CouplingNo: '',
        Facility: ''
      },
      AgreementNo: '',
      AgreementName: '',
      searchVehiclesNum: [],
      vehicleNum: '',
      searchVehicle: '',
      searching: false,
      searchTimer: null,
      createAgreementDelivery: false,
      agreements: [],
      agreementNo: '',
      top: 100,
      searchAgreement: ''
    }
  },
  methods: {
    searchDelayed (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchZipCodes, 300)
      }
    },
    isRequired (fieldName) {
      return true
    },
    searchDelayedAgreement (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchAgreements, 600)
      }
    },
    async updateAgreements (search) {
      this.searching = true
      const res = await Archive.loadAgreements({ facilityNo: this.facilityNo, searchCriteria: search, top: this.top, agreementNoFilter: this.agreementNoFilter })
      // console.log('pip', res)
      if (!res.failed) {
        this.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.searching = false
    },
    searchAgreements () {
      if (this.searchAgreement.length < 1) this.agreements = []
      // Temporary show Search agreement xxx ....
      this.agreements = [this.searchAgreement.length ? this.$t('Searching') + ' ' + this.searchAgreement + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchAgreement) this.updateAgreements(this.searchAgreement)
    },
    async agreementChanged () {
      this.$forceUpdate()
      this.preventLeave = false
      this.delivery.AgreementNo = this.agreementNo
      const res = await Archive.loadAgreement({ facilityNo: this.facilityNo, no: this.delivery.AgreementNo, searchCriteria: null, top: 1, agreementNoFilter: this.agreementNoFilter })
      this.AgreementName = res.data[0]?.Name
    },
    searchZipCodes () {
      // if (this.searchVehicle.length < 2) this.searchVehiclesNum = []
      // Temporary show Search vehicle xxx ....
      // this.searchVehiclesNum = [this.searchVehicle.length > 1 ? this.$t('Searching') + ' ' + this.searchVehicle + ' ...' : this.$t('Search') + ' ' + this.searchVehicle]
      // Only update if not already searching and serarch text is entered
    },
    async setSelectedZipcode () {
      // Sort alphabetically
      this.delivery.SelectedVehiclesNum = this.delivery.SelectedVehiclesNum.sort()
      this.zipCodes = this.delivery.SelectedVehiclesNum
      const res = await loadZipCodes({ facility: this.facilityNo, searchText: this.searchText, loadDeleted: true })
      this.zipCodes = res.data
    },
    async zipCodeChanged () {
      this.$forceUpdate()
      this.preventLeave = true
    },
    validate () {
      if (this.delivery === null) {
        return true
      }

      return this.delivery.CouplingNo === ''
    },
    async submit () {
      this.preventLeave = false
      this.submitting = true
      this.delivery.UpdatedDate = DateUtil.getRealDate(Date.now())
      const res = await saveDeliveriesDetails(this.delivery)
      this.submitting = false
      if (!res.failed) {
        this.$root.$message.showSuccess(this.$t('Delivery') + ' ' + this.$t('Saved'))
        this.$router.push({ name: this.redirectTo })
      }
    }
  },
  async mounted () {
    if (this.$route.params.id) {
      const delivery = this.$route.params.id
      if (delivery.Details) { this.delivery = delivery } else this.delivery.Details = []

      const storedFacilityNo = '' + LocalStorage.load('facilityNo')
      if (storedFacilityNo) this.facilityNo = storedFacilityNo
    }
    this.createAgreementDelivery = Security.user.userDetails.find(d => d.Name === 'CreateDeliveriesAllAgreements')?.Value

    this.facilityNo = this.$route.params.facility
    this.facilityShow = this.facilityNo
    this.delivery.Facility = this.facilityNo
    if (this.$route.params.facilityD !== '') {
      this.facilityShow = this.$route.params.facilityD
    }

    if (this.createAgreementDelivery !== 'true') {
      this.delivery.AgreementNo = Security.user.userDetails.find(d => d.Name === 'CustomerNo')?.Value
      const res = await Archive.loadAgreement({ facilityNo: this.facilityNo, no: this.delivery.AgreementNo, searchCriteria: null, top: 1, agreementNoFilter: this.agreementNoFilter })
      this.AgreementName = res.data[0]?.Name
    }
    this.setSelectedZipcode()
    this.$nextTick(() => {
      this.loading = false
    })
  }
}
</script>
